module.exports = __webpack_public_path__ + "assets/img/case-earth.ac816956.png";